module.exports = __webpack_public_path__ + "img/06.ba8faff8.png";